import { useTranslation } from 'react-i18next';
import type { Locale } from 'antd/es/locale';
import ruRU from 'antd/locale/ru_RU';
import enUS from 'antd/locale/en_US';
import uzUZ from 'antd/locale/uz_UZ';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/uz-latn';

const ANTD_LOCALE: Record<string, Locale> = {
  ru: ruRU,
  uz: uzUZ,
  en: enUS,
};

const DAYJS_LOCALE: Record<string, string> = {
  ru: 'ru',
  uz: 'uz-latn',
  en: 'en',
};

/**
 * Sync antd's ConfigProvider locale + dayjs locale with whatever i18next selected.
 * Defaults to Russian (project convention).
 */
export function useAntdLocale(): Locale {
  const { i18n } = useTranslation();
  const lng = (i18n.resolvedLanguage ?? 'ru').split('-')[0] ?? 'ru';
  dayjs.locale(DAYJS_LOCALE[lng] ?? 'ru');
  return ANTD_LOCALE[lng] ?? ruRU;
}
